import { render, staticRenderFns } from "./EventRegistrationDetails.vue?vue&type=template&id=ac7c028e&scoped=true&"
import script from "./EventRegistrationDetails.vue?vue&type=script&lang=js&"
export * from "./EventRegistrationDetails.vue?vue&type=script&lang=js&"
import style0 from "./EventRegistrationDetails.vue?vue&type=style&index=0&id=ac7c028e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ac7c028e",
  null
  
)

export default component.exports